// extracted by mini-css-extract-plugin
export default {"editor":"achievement-editor_editor__ljby2","formContainer":"achievement-editor_formContainer__5gn9E","videoContainer":"achievement-editor_videoContainer__ZEqh8"};